<template>
  <div class="error-page">
    <p class="error-title">{{ $t('front_end.common.error_page.text_1') }}</p>
    <p class="text">{{ $t(message) }}</p>
    <div class="mb-4" v-if="systemError">
      <p v-html="$t('front_end.common.error_page.text_2')"></p>
      <p v-html="$t('front_end.common.error_page.text_3')"></p>
    </div>
    <button
      type="button"
      @click.prevent="redirectToManage()"
    >{{ $t('front_end.common.error_page.text_4') }}</button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      status: state => state.errorStore.status,
      message: state => state.errorStore.message
    }),
    systemError() {
      return this.systemErrors.indexOf(this.status) !== -1;
    }
  },
  data() {
    return {
      systemErrors: [404, 409, 500, 503]
    };
  },
  methods: {
    redirectToManage() {
      this.$router.push({ name: "a005" });
    }
  }
};
</script>

<style scoped>
.error-page {
  color: #dd0017;
  margin-top: calc(50vh - 200px);
  text-align: center
}
.error-page .text {
  margin: 0 auto;
  width: fit-content;
  font-size: 17px;
  padding-bottom: 30px;
}
.error-title {
  font-size: 24px;
  padding-left: 14px;
  text-align: center;
}
.error-page div {
  margin: 0 auto;
  padding-left: 14px;
  width: fit-content;
  font-size: 16px;
  padding-bottom: 10px;
  display: block;
}
.error-page button {
  margin: 0 auto;
  width: fit-content;
  color: white;
  font-size: 24px;
  padding: 5px 50px;
  background-color: #dd0017;
  border: none;
  display: block;
  font-weight: 200;
}
</style>
